/* eslint-disable prettier/prettier */
<template>
  <footer
    class="footer color-lighten-3"
    :style="`background-image: url(${require('@/assets/isologo.svg')})`"
  >
    <b-container>
      <b-row>
        <b-col md="2"></b-col>
        <b-col sm="6" md="4">
          <h6 :class="['font-weight-light', { h5: isMobile }]">
            {{ content.email }}
          </h6>
          <h6 :class="['font-weight-light', { h5: isMobile }]">
            {{ content.phone }}
          </h6>
          <h6 class="font-weight-light" v-html="content.location"></h6>
        </b-col>
        <b-col sm="6" md="4" :class="['pt-3 pt-sm-0', { 'text-right': !isMobile }]">
          <h6
            v-if="content.provider && content.provider.url"
            class="font-weight-light"
          >
            <a :href="content.provider.url">{{ content.provider.title }}</a>
          </h6>
          <h6 v-if="content.jobs && content.jobs.url" class="font-weight-light">
            <a :href="content.jobs.url">{{ content.jobs.title }}</a>
          </h6>
          <h6 class="font-weight-light" v-if="content.socialmedia">
            {{ content.socialmedia.title }}
            <template v-for="link in content.socialmedia.links">
              <a
                v-if="link.url"
                :href="link.url"
                target="_blank"
                :key="`icon-${link.icon}`"
              >
                <img :src="link.icon" />
              </a>
            </template>
          </h6>
        </b-col>
        <b-col md="2"></b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
import { db } from "@/services/firebase";
import { checkIsMobile } from "@/utils/checkIsMobile";

export default {
  data() {
    return {
      content: {},
      isMobile: checkIsMobile()
    };
  },
  async created() {
    this.content = await db
      .collection("footer")
      .doc("content")
      .get()
      .then((doc) => doc.data());
  }
};
</script>

<style scoped lang="sass">
.footer
  position: relative
  padding: 3rem 0
  background-color: #555B50
  background-position: left center
  background-repeat: no-repeat
  background-size: contain
  @media screen and (max-width: 502px)
    padding: 3rem 1.5rem
    text-align: center
  &:before
    content: ""
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    background: linear-gradient(#555b5000, #353833)
  h6
    margin-bottom: 0.75rem
    img
      width: 24px
      margin-left: 0.25rem
      opacity: 0.7
      transition: all 400ms ease
      &:hover, &:active
        opacity: 1
    a
      text-decoration: none
      color: inherit
      transition: all 400ms ease
      &:hover, &:active
        text-decoration: underline
</style>
